<template>
  <div class="cell space-1 small-12 medium-4 text-left space-left space-right">
    <h3>&#10097; {{ topic }}</h3>
    <hr>
    <p class="no-padding">{{ explain }}</p>
  </div>
</template>

<script>
export default {
  name: 'ServiceFocus',
  props: ['topic', 'explain']
}
</script>

<style lang="scss" scoped>
div {
}
</style>
